module.exports = __webpack_public_path__ + "img/trgl-20.15c94b85.svg";